"use strict";
/**
 * Executes a list of promise generators sequentially (one by one).
 * Every next promise generator starts only after the previous one is resolved.
 * It should be used in case of promises set that cannot be run in parallel by using Promise.all.
 *
 * @param promiseGenerators - List of promise generators (functions that return promise) to execute.
 * @returns List of promise responses (the same as Promise.all).
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeSequentially = executeSequentially;
async function executeSequentially(promiseGenerators) {
    const responses = [];
    for (const promiseGenerator of promiseGenerators) {
        responses.push(await promiseGenerator());
    }
    return responses;
}
//# sourceMappingURL=executeSequentially.js.map